import Component from '../component';

export default class HistorySlider extends Component {
    constructor(...args) {
        super(...args);

        this._isDesktop = (ENV.template == 'desktop');
        this._retrieveDom();
    }

    /**
     * init slideShow
     */
    init() {

        if( this._isDesktop ) {
            this._setHeightLegend();
        }

        if( this.sliderExist ) {
            this._createSlider();
            this._initSliderEvents();
            this._setControls();
            this._setSlideIndex();

            this._current = 0;
        }
    }

    /**
     * Create Flickity slideshow from dom component
     * @private
     */
    _createSlider() {
        // initialize flickity slider
        this.flktySlider = new Flickity(  this.dom.sliderContainer, {
            // options...
            // cellSelector: '.flexible-slideshow-slide',
            // adaptiveHeight: true,
            wrapAround: true,
            prevNextButtons: false,
            pageDots: false
        });
    }

    /**
     * Get dom slideshow elements
     * @private
     */
    _retrieveDom() {
        // Navigation buttons
        this.dom.btnPrev = this.dom.component.querySelector('.prev');
        this.dom.btnNext = this.dom.component.querySelector('.next');

        // Flickity container
        this.dom.sliderContainer = this.dom.component.querySelector('.flickity-container');

        // Slide
        this.dom.slides = this.dom.component.querySelectorAll('.flexible-slideshow-slide');
        this.sliderExist = (this.dom.slides.length > 0);

        // Legend container
        this.dom.legendContainer = this.dom.component.querySelector('.slider-legend');
        this.dom.legendItem = [].slice.call( this.dom.component.querySelectorAll('.legend-item') );

        // Slider index
        this.dom.indexIndicWrapper = this.dom.component.querySelector('.index-indic-wrapper');
        this.dom.indexIndic = this.dom.component.querySelector('.index-indic');
    }

    /**
     * Set slideshow control buttons
     * @private
     */
    _setControls() {
        // previous
        if( this.dom.btnPrev ) {
            this.dom.btnPrev.addEventListener( 'click', () => {
                this.flktySlider.previous(true);
            });
        }

        // next
        if( this.dom.btnNext ) {
            this.dom.btnNext.addEventListener( 'click', () => {
                this.flktySlider.next(true);
            });
        }
    }

    /**
     * Fill slideshow index indicator
     * @private
     */
    _setSlideIndex() {
        // set slides length
        const slideLength = this.flktySlider.slides.length;

        if( this.flktySlider.selectedIndex )
            this._updateSlideIndex(this.flktySlider.selectedIndex);
    }

    /**
     * Update slide index in index indic
     * @param {int} index - Target Slide index
     * @private
     */
    _updateSlideIndex(index) {
        let next = index;
        // Clone and add new index
        index += 1;
        const newIndexIndic = this.dom.indexIndic.cloneNode();
        newIndexIndic.textContent  = index < 10 ? '0' + index : index;
        this.dom.indexIndicWrapper.appendChild(newIndexIndic);

        // animate new tl
        const tl = new TimelineMax();
        tl.set(newIndexIndic, {y: '100%'})
            .to(newIndexIndic, 0.6, {y: '0%', ease: Power3.easeInOut})
            .to(this.dom.indexIndic, 0.6, {y: '-100%', ease: Power3.easeInOut}, 0)
            .add(() => {
                // remove old
                this.dom.indexIndicWrapper.removeChild(this.dom.indexIndic);
                // set new index element tu current
                this.dom.indexIndic = newIndexIndic;
            })

        // animate new tl
        const tl_legend = new TimelineMax();
        tl_legend.set(this.dom.legendItem[next], {y: '100%'})
            .to(this.dom.legendItem[next], 0.6, {y: '0%', ease: Power3.easeInOut})
            .to(this.dom.legendItem[this._current], 0.6, {y: '-100%', ease: Power3.easeInOut}, 0)
            .add(() => {
                // set new index element to current
                this._current = next;
            })
    }

    /**
     * init slideshow events
     * @private
     */
    _initSliderEvents() {
        this.flktySlider.on( 'change', (index) => this._handleSlideChange(index));
    }

    /**
     * handle slideshow on slide change
     * @param {int} index - Target Slide index
     * @private
     */
    _handleSlideChange(index) {
        this._updateSlideIndex(index);
    }

    _setHeightLegend() {

        let heightMaxLegend = 0
        for( let i = 0, j = this.dom.legendItem.length; i < j; i++ ) {

            if( this.dom.legendItem[i].getBoundingClientRect().height > heightMaxLegend ) {
                heightMaxLegend = this.dom.legendItem[i].getBoundingClientRect().height;
            }
        }
        if( this.dom.legendContainer )
            this.dom.legendContainer.style.height = heightMaxLegend + 'px';

    }

    resize() {
        if( this._isDesktop ) {
            this._setHeightLegend();
        }
    }

}



// WEBPACK FOOTER //
// ./src/js/components/history-slider/history-slider.js